import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/diners-club.vue
var o = {
	name: "DtIconDinersClub",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--diners-club"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Diners Club",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("rect", {
		x: ".25",
		y: "3.75",
		width: "23.5",
		height: "16.5",
		rx: "1.75",
		fill: "#fff",
		stroke: "#E3E5E8",
		"stroke-width": ".5"
	}, null, -1), r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M11.18 16.623h1.833c2.86 0 5.14-2.269 5.229-5.072v-.045c-.045-2.848-2.369-5.162-5.23-5.117h-2.055c-2.727.089-4.872 2.403-4.783 5.162 0 2.759 2.235 5.028 5.006 5.072Zm-4.112-5.117c0-2.314 1.922-4.227 4.246-4.227 2.324 0 4.246 1.913 4.246 4.227s-1.922 4.227-4.246 4.227c-2.324 0-4.246-1.913-4.246-4.227Zm4.917 2.848V8.703c1.564.4 2.547 1.958 2.145 3.515a2.904 2.904 0 0 1-2.145 2.136Zm-3.442-3.56a2.924 2.924 0 0 0 2.1 3.56V8.703a2.933 2.933 0 0 0-2.1 2.091Z",
		fill: "#0079BE"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=diners-club.js.map